import 'core-js/modules/es.object.assign.js';
import { __rest } from '../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { FormControl as FormControl$1, InputLabel, Select as Select$1 } from '@mui/material';
import { styled, css } from '@mui/material/styles';
import { withUtility } from '../../foundation/utils.js';

let _ = t => t,
  _t,
  _t2,
  _t3;
const FormControl = styled(FormControl$1)(_t || (_t = _`
  min-width: 220px;

  ${0}

  ${0}
`), withUtility(({
  palette
}) => css(_t2 || (_t2 = _`
      .MuiOutlinedInput-root fieldset {
        border-color: ${0};
      }
    `), palette('outline'))), withUtility(({}, {
  fullWidth
}) => {
  if (!fullWidth) {
    return;
  }
  return css(_t3 || (_t3 = _`
      width: 100%;
      min-width: auto;
    `));
}));
const Select = _a => {
  var {
      children,
      size,
      label,
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mr,
      mt,
      mx,
      my
    } = _a,
    props = __rest(_a, ["children", "size", "label", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight", "m", "marginX", "marginY", "mb", "ml", "mr", "mt", "mx", "my"]);
  return jsxs(FormControl, Object.assign({
    size: size,
    error: props.error,
    fullWidth: props.fullWidth,
    disabled: props.disabled,
    sx: {
      margin,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      m,
      marginX,
      marginY,
      mb,
      ml,
      mt,
      mr,
      mx,
      my
    }
  }, {
    children: [jsx(InputLabel, {
      children: label
    }), jsx(Select$1, Object.assign({
      size: size
    }, props, {
      label: label
    }, {
      children: children
    }))]
  }));
};

export { Select };
